import React from "react";

function Footer() {
  return (
    <div className="treasure" style={{ backgroundColor: "#0A2648",color:"white" }}>
      {/* <!-- Footer Start --> */}
      <footer>
        <div class="container mt-4 mb-5 pb-5 ">
          <div class="row p-3">
            <div style={{ width: "120px" }}>
              <img src="img/logo.png" alt="" style={{ width: "100%" }}/>
            </div>
            <div class="mt-2">
              <p class="text-white">
                <small>
                 
                </small>
              </p>
            </div>

            <div class="d-flex justify-content-between">
              <div>
                <a class="text-decoration-none" href="">
                  <img
                    class="border rounded-5 p-2 footer-socalmedia w-100"
                    src="img/icons8-linkedin-25.png"
                    alt=""
                  />
                </a>
              </div>

              <div>
                <a class="text-decoration-none" href="">
                  <img
                    class="border rounded-5 p-2 footer-socalmedia w-100"
                    src="img/icons8-youtube-25.png"
                    alt=""
                  />
                </a>
              </div>

              <div>
                <a class="text-decoration-none" href="">
                  <img
                    class="border rounded-5 p-2 footer-socalmedia w-100"
                    src="img/icons8-twitter-bird-25.png"
                    alt=""
                  />
                </a>
              </div>

              <div>
                <a class="text-decoration-none" href="">
                  <img
                    class="border rounded-5 p-2 footer-socalmedia w-100"
                    src="img/icons8-facebook-25.png"
                    alt=""
                  />
                </a>
              </div>

              <div>
                <a class="text-decoration-none" href="">
                  <img
                    class="border rounded-5 p-2 footer-socalmedia w-100"
                    src="img/icons8-instagram-25.png"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-6 col-md-4 my-2 ">
                <h5 class="fw-bold" >Resources</h5>
                <a class="text-decoration-none text-muted" href=""  stytle={{ textDecoration: "white"}}>
                  <p>
                    <small>Docs</small>
                  </p>
                </a>
                <a class="text-white" href=""  >
                  <p>
                    <small>Home</small>
                  </p>
                </a>
                <a class="text-decoration-none text-white"  href="/myabout">
                  <p>
                    <small>About Us</small>
                  </p>
                </a>
                <a class="text-decoration-none text-white" href="/blognew">
                  <p>
                    <small>Our Blogs</small>
                  </p>
                </a>
                <a class="text-decoration-none text-white" href="/ongoing_project">
                  <p>
                    <small>Project</small>
                  </p>
                </a>
              </div>
              <div class="col-6 col-md-4 my-2">
                <h5 class="fw-bold">News</h5>
                <a class="text-decoration-none text-white" href="/blognew">
                  <p>
                    <small>Blog</small>
                  </p>
                </a>
              </div>
              <div class="col-12 col-md-4 my-2">
                <h5 class="fw-bold">Company</h5>
                <p class="text-white">
                  <small>
                    Gateway Landmark Grouphas been a trailblazer in delivering world-class luxury properties in Jaipur for over 15 years, redefining standards in the real estate industry.
                  </small>
                </p>
              </div>
            </div>

            <div class="border rounded-3 d-flex p-1">
              <input
                class="w-100  border-0 form-control  shadow-none"
                type="email"
                placeholder="Enter your email address"
              />
              <button class="btn btn-sm border rounded-3 footer-email-btn text-white">
                Submit
              </button>
            </div>

            <div class="mt-4">
              <a class="text-decoration-none" href="">
                <p class="text-white text-center">
                  ©2025 -   Gateway Landmark Group ALL RIGHTS RESERVED
                </p>
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- Footer End --> */}
    </div>
  );
}

export default Footer;
